// extracted by mini-css-extract-plugin
export default {"carousel":"pF-z"};